import React, { useMemo } from 'react';
import { Tag, X } from 'lucide-react';
import { tagIdsOf } from '../epmHelpers';

// Tag chips above the board: a card shows when it has any selected tag
const TagFilter = ({ tests, tagsMap, selected, onChange }) => {
    const tags = useMemo(() => {
        const counts = {};
        (tests || []).forEach((test) => tagIdsOf(test).forEach((id) => { counts[id] = (counts[id] || 0) + 1; }));
        return Object.values(tagsMap || {})
            .map((tag) => ({ id: String(tag._id), name: tag.name, count: counts[String(tag._id)] || 0 }))
            .filter((tag) => tag.count > 0)
            .sort((a, b) => b.count - a.count || a.name.localeCompare(b.name));
    }, [tests, tagsMap]);

    if (!tags.length) return null;

    const toggle = (id) => onChange(selected.includes(id) ? selected.filter((value) => value !== id) : [...selected, id]);

    return (
        <div className="flex items-center gap-2 flex-wrap min-w-0" role="group" aria-label="Filter by tag">
            <span className="inline-flex items-center gap-1.5 text-xs font-semibold text-gray-500 mr-1">
                <Tag size={13} className="text-gray-400" /> Filter by tag:
            </span>
            {tags.map((tag) => {
                const isActive = selected.includes(tag.id);
                return (
                    <button
                        key={tag.id}
                        type="button"
                        aria-pressed={isActive}
                        onClick={() => toggle(tag.id)}
                        className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-full border text-xs font-medium transition-all cursor-pointer ${
                            isActive
                                ? 'bg-primary border-primary text-white shadow-xs'
                                : 'bg-white border-gray-200 text-gray-700 hover:border-gray-300 hover:bg-gray-50'
                        }`}
                    >
                        <span>{tag.name}</span>
                        <span className={`text-[10px] font-bold px-1.5 py-0.2 rounded-full ${isActive ? 'bg-white/20 text-white' : 'bg-gray-100 text-gray-500'}`}>
                            {tag.count}
                        </span>
                    </button>
                );
            })}
            {selected.length > 0 && (
                <button
                    type="button"
                    onClick={() => onChange([])}
                    className="inline-flex items-center gap-1 px-2.5 py-1 text-xs font-medium text-gray-500 hover:text-red-600 transition-colors cursor-pointer"
                >
                    <X size={13} /> Clear all
                </button>
            )}
        </div>
    );
};

export default TagFilter;
